// Helpers para generar JSON-LD estructurado según schema.org

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "AccountingService",
  "name": "Estudio Contable Vanesa Mondejar",
  "alternateName": "Vanesa Mondejar Estudio Contable",
  "description": "Estudio contable profesional especializado en servicios contables, impositivos y asesoramiento empresarial. Más de 10 años de experiencia brindando soluciones integrales para empresas.",
  "url": "https://vanesamondejar.com", // TODO: Cambiar por URL real
  "telephone": "+54 9 11 6620-1346",
  "email": "estudiomondejar@yahoo.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pedernera 89 oficina A",
    "addressLocality": "Lomas de Zamora",
    "addressRegion": "Buenos Aires",
    "postalCode": "B1832",
    "addressCountry": "AR"
  },
  "founder": {
    "@type": "Person",
    "name": "Vanesa Mondejar",
    "jobTitle": "Contadora Pública",
    "description": "Contadora Pública con más de 10 años de experiencia en servicios contables profesionales"
  },
  "serviceArea": {
    "@type": "Country",
    "name": "Argentina"
  },
  "priceRange": "$$", // TODO: Definir rango de precios
  "openingHours": "Mo-Fr 08:00-17:00",
  "keywords": "estudio contable, vanesa mondejar, estudio contable vanesa mondejar, servicios contables, contador, contadora, asesoramiento impositivo, liquidacion de sueldos, consultoria empresarial",
  "sameAs": [
    // TODO: Agregar redes sociales reales
  ]
})

export const generateServiceSchema = (serviceName, description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": serviceName,
  "description": description,
  "provider": {
    "@type": "AccountingService",
    "name": "Estudio Contable Vanesa Mondejar",
    "url": "https://vanesamondejar.com"
  },
  "serviceType": "Accounting Services",
  "areaServed": {
    "@type": "Country",
    "name": "Argentina"
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://vanesamondejar.com/contacto",
    "servicePhone": "+54 9 11 6620-1346"
  }
})

export const generateWebSiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Estudio Contable Vanesa Mondejar",
  "alternateName": "Vanesa Mondejar Estudio Contable",
  "url": "https://vanesamondejar.com", // TODO: Cambiar por URL real
  "description": "Estudio contable profesional especializado en servicios contables, impositivos y asesoramiento empresarial. Más de 10 años de experiencia.",
  "keywords": "estudio contable, vanesa mondejar, estudio contable vanesa mondejar, servicios contables profesionales",
  "inLanguage": "es-AR",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://vanesamondejar.com/search?q={search_term_string}", // TODO: Implementar búsqueda si es necesario
    "query-input": "required name=search_term_string"
  },
  "publisher": {
    "@type": "AccountingService",
    "name": "Estudio Contable Vanesa Mondejar"
  }
})
